import { createRouteRef } from "@backstage/core-plugin-api";

export const pluginId = "admin";

/** Root route ref for the admin plugin. */
export const rootRouteRef = createRouteRef({
    id: pluginId,
});
